import { ReactNode } from 'react';
import { useObjectContext } from '../hooks/useObjectContext';

interface ObjectContentProps {
  children: (activeTab: string) => ReactNode;
}

export function ObjectContent({ children }: ObjectContentProps) {
  const { activeTab } = useObjectContext();

  return <>{children(activeTab)}</>;
}
